export default "__VITE_ASSET__D9NB97JK__"